/**
 * The 2FA backup code is shown and typed as xxxx-xxxx-xxxx-xxxx, but the API only accepts the bare
 * characters (e.g. 274c13b91a6f6402). Keeps the letters and digits, dropping whatever separators
 * were typed or pasted.
 */
export const formatBackupCode = (code: string): string => code.replace(/[^\p{L}\d]/gu, '')
